import React from "react";
import { UsersLoadingDialog } from "./users-loading-dialog/UsersLoadingDialog";
import { UsersUIProvider } from "./UsersUIContext";
import { UsersCard } from "./UsersCard";

export function UsersPage({ history }) {
  const customersUIEvents = {};

  return (
    <UsersUIProvider customersUIEvents={customersUIEvents}>
      <UsersLoadingDialog />
      <UsersCard />
    </UsersUIProvider>
  );
}
